<template>
  <div class="container-performance">
    <div class="commission-main">
      <div class="search-block">
        <input v-model="hostessId" maxlength="30" placeholder="Hostess ID" />
        <div></div>
        <img src="../images/search.png" alt="" @click.self="handleSearch" />
      </div>

      <!-- Hostess Performance -->
      <div class="card-block">
        <div class="switch-tab">
          <div class="tab" :class="{ 'active-tab': tabIndex == 0 }" @click="changeTab(0)">{{ $t('lang.Invite.k003') }}</div>
          <div class="tab" :class="{ 'active-tab': tabIndex == 1 }" @click="changeTab(1)">{{ $t('lang.Invite.k012') }}</div>
          <div class="tab" :class="{ 'active-tab': tabIndex == 2 }" @click="changeTab(2)">{{ $t('lang.Invite.k007') }}</div>
        </div>

        <div class="deliver-line"></div>

        <div class="date-block">
          <!-- prettier-ignore -->
          <div class="total-income">
            {{ $t('lang.BaseCommon.k035') }}: <i>{{ totalIncome }}</i> <img :src="getMatchImg('beans')" />
          </div>
          <!-- prettier-ignore -->
          <div v-if="tabIndex == 0" class="choose-date">
            <!-- 下拉框 -->
            <div class="btn" @click="selectMonthShow">
              {{ monthSelectedTxt }}<img :class="{ 'active-img': monthShowSelect }" src="@/assets/packageAssets/common/arrow06.png" alt="" />
            </div>
            <!-- 下拉选项 -->
            <div class="select" v-if="monthShowSelect">
              <div @click="selectMonth(1)">{{ $t('lang.Invite.k004') }}</div>
              <div @click="selectMonth(2)">{{ $t('lang.Invite.k005') }}</div>
            </div>
          </div>

          <!-- prettier-ignore -->
          <div v-if="tabIndex == 1" class="choose-date">
            <!-- 下拉框 -->
            <div class="btn" @click="selectWeekShow">
              {{ weekSelectedTxt }}<img :class="{ 'active-img': weekShowSelect }" src="@/assets/packageAssets/common/arrow06.png" alt="" />
            </div>
            <!-- 下拉选项 -->
            <div class="select" v-if="weekShowSelect">
              <div @click="selectWeek(1)">{{ $t('lang.BaseCommon.k034') }}</div>
              <div @click="selectWeek(2)">{{ $t('lang.BaseCommon.k042') }}</div>
            </div>
          </div>

          <!-- prettier-ignore -->
          <div v-if="tabIndex == 2" class="choose-date">
            <!-- 下拉框 -->
            <div class="btn" @click="selectDay">
              {{ handleMoment(chooseTime, 'YYYY-MM-DD') }}
              <img :class="{ 'active-img': showPop }" src="@/assets/packageAssets/common/arrow06.png" alt="" />
            </div>
          </div>
        </div>

        <div class="list-fields">
          <div class="field field1">{{ $t('lang.BaseCommon.k103') }}</div>
          <div class="field field2">
            {{ $t('lang.BaseCommon.k032') }}
            <img :src="getMatchImg('beans')" />
          </div>
          <div class="field field3">
            {{ $t('lang.BaseCommon.k031') }}
            <img :src="getMatchImg('beans')" />
          </div>
        </div>

        <div class="list-fields" v-for="(item, index) in listData" :key="item.index">
          <div class="bd-field field1 user-info">
            <div class="list-rank">
              <div v-if="index == 0" class="num first">1</div>
              <div v-else-if="index == 1" class="num second">2</div>
              <div v-else-if="index == 2" class="num third">3</div>
              <div v-else class="num normal">{{ index + 1 }}</div>
            </div>
            <div class="name-id">
              <div class="name-wrap">
                <span>{{ item.nickname }}</span>
                <img :src="item.locationFlag | imgPath" />
              </div>
              <div class="id-wrap" @click="handleCopy(item.presentId, $t('lang.BaseCommon.k071'))">
                ID:{{ item.presentId }}
                <img src="../images/copy-gray.png" alt="" />
              </div>
            </div>
          </div>
          <div class="bd-field field2">{{ item.hostIncome }}</div>
          <div class="bd-field field3">{{ item.hostIncomeCommission }}</div>
        </div>

        <div v-if="loading" class="is-loading">
          <van-loading size="24px" />
        </div>
        <div v-if="finished && listData.length" class="no-more">{{ $t('lang.BaseCommon.k087') }}</div>
      </div>

      <div style="height: 350px"></div>
    </div>

    <CTimeDay :showPop="showPop" :minDate="minDate" @handleCurrentDate="handleCurrentDate" />
  </div>
</template>

<script>
import { apiFetchMonthIncome, apiFetchWeekIncome, apiFetchDailyIncome } from '@/api/imee'

import CTimeDay from '@/components/CTimeDay'
import moment from 'moment'
import eventBus from '@/utils/eventbus'

export default {
  components: { CTimeDay },
  props: {
    info: {
      type: Object,
      default: () => {
        return undefined
      },
    },
  },
  data() {
    return {
      tabIndex: 1,

      // 查询
      hostessId: '',
      limit: 10,
      offset: 0,
      loading: false,
      finished: false,

      // 月选择
      monthShowSelect: false,
      monthSelectedTxt: this.$t('lang.Invite.k004'),
      monthSelected: 1,

      // 周选择
      weekShowSelect: false,
      weekSelectedTxt: this.$t('lang.BaseCommon.k034'),
      weekSelected: 1,

      // 日选择
      chooseTime: new Date(),
      showPop: false,
      minDate: new Date(Date.now() - 90 * 24 * 60 * 60 * 1000),

      // 结果
      listData: [],
      monthData: {},
      weekData: {},
      dayData: {},
    }
  },
  computed: {
    activeData() {
      if (this.tabIndex == 0) return this.monthData
      if (this.tabIndex == 1) return this.weekData
      if (this.tabIndex == 2) return this.dayData
    },
    totalIncome() {
      return this.activeData.totalHostIncome ?? this.activeData.hostIncomeSum ?? 0
    },
  },
  methods: {
    handleSearch() {
      // 月
      if (this.tabIndex == 0) {
        this.resetList()
        this.fetchMonthIncome(this.monthSelected)
        return
      }

      // 周
      if (this.tabIndex == 1) {
        this.resetList()
        this.fetchWeekIncome(this.weekSelected)
        return
      }

      // 日
      if (this.tabIndex == 2) {
        this.resetList()
        this.fetchDailyIncome(this.chooseTime)
      }
    },

    resetList() {
      this.listData = []
      this.offset = 0
      this.loading = false
      this.finished = false
    },

    // 获得月收益列表  1-本月 2-上月
    fetchMonthIncome(type) {
      if (this.loading || this.finished) return
      this.loading = true
      apiFetchMonthIncome({
        hostId: this.hostessId,
        limit: this.limit,
        offset: this.offset,
        timeType: type,
      }).then((res) => {
        if (res) {
          this.monthData = res
          const items = res.hostIncomes || []
          this.listData = this.listData.concat(items)
          this.offset = this.listData.length
          this.loading = false
          this.finished = items.length < this.limit

          if (!this.finished) {
            this.$parent.nativeScroll && this.$parent.nativeScroll.finishPullUp()
          }
          this.$nextTick(() => {
            this.$parent.nativeScroll && this.$parent.nativeScroll.refresh()
          })
        }
      })
    },

    // 获得周收益列表  1-本周 2-上周
    fetchWeekIncome(type) {
      if (this.loading || this.finished) return
      this.loading = true
      const params = {
        hostId: this.hostessId,
        limit: this.limit,
        offset: this.offset,
        timeType: type,
      }
      apiFetchWeekIncome(params).then((res) => {
        if (res) {
          this.weekData = res
          const items = res.hostIncomes || []
          this.listData = this.listData.concat(items)
          this.offset = this.listData.length
          this.loading = false
          this.finished = items.length < this.limit

          if (!this.finished) {
            this.$parent.nativeScroll && this.$parent.nativeScroll.finishPullUp()
          }
          this.$nextTick(() => {
            this.$parent.nativeScroll && this.$parent.nativeScroll.refresh()
          })
        }
      })
    },

    // 获得日收益列表
    fetchDailyIncome(val) {
      if (this.loading || this.finished) return
      this.loading = true
      const params = {
        hostId: this.hostessId,
        limit: this.limit,
        offset: this.offset,
        agentDay: moment(val).format('yyyy-MM-DD'),
      }
      apiFetchDailyIncome(params).then((res) => {
        if (res) {
          this.dayData = res
          const items = res.hostIncomes || []
          this.listData = this.listData.concat(items)
          this.offset = this.listData.length
          this.loading = false
          this.finished = items.length < this.limit

          if (!this.finished) {
            this.$parent.nativeScroll && this.$parent.nativeScroll.finishPullUp()
          }
          this.$nextTick(() => {
            this.$parent.nativeScroll && this.$parent.nativeScroll.refresh()
          })
        }
      })
    },

    // tab选中
    changeTab(tabIndex) {
      this.tabIndex = tabIndex

      this.monthShowSelect = false
      this.weekShowSelect = false
      this.resetList()

      // 月
      if (tabIndex == 0) {
        this.fetchMonthIncome(this.monthSelected)
        return
      }

      // 周
      if (tabIndex == 1) {
        this.fetchWeekIncome(this.weekSelected)
        return
      }

      // 日
      if (tabIndex == 2) {
        this.fetchDailyIncome(this.chooseTime)
      }
    },

    // 月选择
    selectMonthShow() {
      this.monthShowSelect = !this.monthShowSelect
    },
    selectMonth(type) {
      switch (type) {
        case 1:
          this.monthSelectedTxt = this.$t('lang.Invite.k004')
          this.monthSelected = 1
          break
        case 2:
          this.monthSelectedTxt = this.$t('lang.Invite.k005')
          this.monthSelected = 2
          break
      }
      this.resetList()
      this.fetchMonthIncome(type)
      this.monthShowSelect = false
    },

    // 周选择
    selectWeekShow() {
      this.weekShowSelect = !this.weekShowSelect
    },
    // 周选择
    selectWeek(type) {
      switch (type) {
        case 1:
          this.weekSelectedTxt = this.$t('lang.BaseCommon.k034')
          this.weekSelected = 1
          break
        case 2:
          this.weekSelectedTxt = this.$t('lang.BaseCommon.k042')
          this.weekSelected = 2
          break
      }
      this.resetList()
      this.fetchWeekIncome(type)
      this.weekShowSelect = false
    },

    // 日选择
    selectDay() {
      this.weekShowSelect = !this.weekShowSelect
      this.showPop = true
    },
    // 日选择
    handleCurrentDate(val) {
      this.chooseTime = val
      this.resetList()
      this.fetchDailyIncome(this.chooseTime)
    },
    // 关闭弹框
    closePop() {
      this.showPop = false
    },

    scrollEvent(arg) {
      if (arg.type === 'arriveBottom') {
        if (this.tabIndex == 0) {
          this.fetchMonthIncome(this.monthSelected)
        } else if (this.tabIndex == 1) {
          this.fetchWeekIncome(this.weekSelected)
        } else if (this.tabIndex == 2) {
          this.fetchDailyIncome(this.chooseTime)
        }
      }
    },
  },
  created() {
    eventBus.$on('InviteScroll', this.scrollEvent)
    this.fetchWeekIncome(this.weekSelected)
  },
  beforeDestroy() {
    eventBus.$off('InviteScroll', this.scrollEvent)
  },
}
</script>
<style lang="scss" scoped>
.container-performance {
  width: 100%;
  min-height: 812px;

  .commission-main {
    padding-bottom: 60px;
    .search-block {
      width: 343px;
      margin: 6px auto 0;
      padding: 4px 12px;
      display: flex;
      align-items: center;
      border-radius: 4px;
      background: #ffffff;

      input {
        height: 20px;
        flex: 1;
        font-size: var(--fs-16);
        line-height: var(--lh-body-24);
        &::placeholder {
          font-family: 'HindMadurai';
          font-weight: var(--fw-400);
          font-size: var(--fs-14);
          line-height: var(--lh-label-16);
          color: #cdcdd4;
        }
      }
      div {
        width: 1px;
        height: 18px;
        margin: 0 4px;
        border-radius: 2px;
        background: var(--Card-Card-1, #eeeef1);
      }
      img {
        box-sizing: content-box;
        width: 20px;
        height: 20px;
        border: 4px solid transparent;
        margin: 0 4px;
      }
    }

    .card-block {
      width: 343px;
      min-height: 320px;
      background: #ffffff;
      border-radius: 8px;
      margin: 16px auto 16px;
      position: relative;

      .switch-tab {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-around;
        padding-top: 12px;
        background-color: #ffffff;
        border-radius: 8px;
        .tab {
          min-height: 26px;
          padding: 0 10px 4px;
          font-family: var(--string-font);
          font-weight: var(--fw-400);
          font-size: var(--fs-16);
          color: #b2b2b2;
          line-height: var(--lh-body-20);
          text-align: center;

          &.active-tab {
            color: var(--commission-tab-active-color);
            position: relative;
            font-weight: bold;
            &::after {
              content: '';
              position: absolute;
              left: 50%;
              bottom: 0;
              width: 35px;
              height: 2px;
              margin-left: -17.5px;
              background-color: var(--commission-tab-active-color);
            }
          }
        }
      }

      // hostess
      .deliver-line {
        width: 319px;
        height: 1px;
        margin: 0 auto;
        transform: rotateX(45deg);
        background: #ededed;
      }

      .date-block {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 12px 12px 0;
        .total-income {
          font-family: 'InterTight-Regular';
          font-weight: var(--fw-400);
          font-size: var(--fs-16);
          line-height: var(--lh-label-18);
          color: #333333;
          display: flex;
          align-items: center;
          i {
            color: var(--commission-tab-active-color);
            margin: 0 3px;
          }
          img {
            width: 18px;
            height: 18px;
          }
        }
        .choose-date {
          border-radius: 30px;
          box-sizing: border-box;
          border: 1px solid #ededed;
          background: #fff;

          position: relative;
          font-size: var(--fs-14);
          line-height: var(--lh-body-20);
          .btn {
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 7px 26px 7px 10px;
            color: #333333;
            background: #ffffff;
            border-radius: 30px;
            position: relative;
            > img {
              position: absolute;
              right: 4px;
              width: 16px;
            }
            .active-img {
              rotate: 180deg;
            }
          }
          .select {
            position: absolute;
            z-index: 100;
            width: 107px;
            margin-top: 8px;
            background: #f9f9fb;
            border-radius: 6px;
            color: #666666;
            font-size: var(--fs-14);
            box-shadow: 1px 1px 10px 0px rgba(0, 0, 0, 0.1);
            > div {
              height: 30px;
              margin: 5px 0;
              line-height: var(--lh-title-28);
              text-align: center;
            }
          }
        }
      }

      .list-fields {
        width: 100%;
        display: flex;
        padding: 0 12px;
        margin: 14px 0;
        .field {
          font-family: var(--string-font);
          font-weight: var(--fw-400);
          font-size: var(--fs-14);
          line-height: var(--lh-body-20);
          color: #b2b2b2;
          text-align: center;
          img {
            width: 14px;
            height: 14px;
            vertical-align: middle;
          }
        }
        .field1 {
          width: 132px;
        }
        .field2 {
          flex: 1;
        }
        .field3 {
          width: 105px;
        }

        .bd-field {
          min-height: 36px;
          font-family: var(--string-font);
          font-weight: var(--fw-400);
          font-size: var(--fs-16);
          line-height: var(--lh-body-24);
          color: #333333;
          text-align: center;
          &.field2 {
            line-height: var(--lh-headline-36);
          }
          &.field3 {
            line-height: var(--lh-headline-36);
          }
          &.user-info {
            display: flex;
            .list-rank {
              box-sizing: content-box;
              height: 100%;
              width: 16px;
              display: flex;
              align-items: center;
              padding-right: 8px;
              .num {
                width: 16px;
                height: 16px;
                line-height: var(--lh-label-16);
                border-radius: 50%;
                font-family: var(--string-font);
                font-weight: var(--fw-400);
                font-size: var(--fs-12);
                color: #ffffff;
              }
              .num.first {
                background-color: #fed141;
              }
              .num.second {
                background-color: #bc6cff;
              }
              .num.third {
                background-color: #aabfff;
              }
              .num.normal {
                color: #333333;
              }
            }
            .name-id {
              text-align: left;
              .name-wrap {
                max-width: 98px;
                font-size: 0;
                text-align: left;
                display: flex;
                align-items: center;
                span {
                  max-width: 80px;
                  font-family: var(--string-font);
                  font-weight: var(--fw-400);
                  font-size: var(--fs-16);
                  line-height: var(--lh-body-24);
                  color: #333333;
                  text-align: left;
                  overflow: hidden;
                  white-space: nowrap;
                }
                img {
                  width: 12px;
                  height: 12px;
                  border-radius: 50%;
                  margin-left: 5px;
                  margin-top: 2px;
                  border: 0.5px solid rgba(102, 102, 102, 0.1);
                }
              }
              .id-wrap {
                display: inline-block;
                margin-top: 4px;
                font-family: var(--string-font);
                font-weight: var(--fw-400);
                font-size: var(--fs-12);
                line-height: var(--lh-body-18);
                color: #b2b2b2;
                text-align: left;
                position: relative;
                word-break: break-all;
                img {
                  width: 12px;
                  height: 12px;
                  margin-left: 4px;
                  position: absolute;
                  top: 50%;
                  right: -17px;
                  margin-top: -5px;
                }
              }
            }
          }
        }
      }

      .is-loading {
        padding: 10px 0;
        text-align: center;
      }

      .no-more {
        padding: 10px 0;
        text-align: center;
        color: #b2b2b2;
        font-size: var(--fs-16);
        line-height: var(--lh-body-24);
      }

      .more-performance {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        line-height: var(--lh-body-18);
        text-align: center;
        padding: 10px 0 24px;
        span {
          font-family: var(--string-font);
          font-size: var(--fs-16);
          line-height: var(--lh-body-24);
          color: var(--commission-more-perf-color);
        }
        img {
          display: inline-block;
          width: 12px;
          height: 12px;
          margin-top: 2px;
        }
      }
    }
  }
}

// html[lang='ar'],
// html[lang='fa'],
// html[lang='he'] {
// }
</style>
